"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginPage_1 = require("./LoginPage");
exports.default = LoginPage_1.default;
//# sourceMappingURL=index.js.map